import { useState } from "react";
import { BASE_API } from '../api/Globals';
import { helpHttp } from "../helpers/helpHttp";
import { storage } from "../helpers/storage";

export const useFormValidationProcess = (initialForm, validateForm, adjuntoid) => {

	const [form, setForm] = useState(initialForm);
	const [errors, setErrors] = useState({});
	const [loadup, setLoading] = useState(false);
	const [response, setResponse] = useState(null);
	const [message, setMessage] = useState(false);
	const [terminado, setTerminado] = useState(false);

	const handleChange = (e) => {
		const { name, value } = e.target;

		setForm({
			...form,
			[name]: value,
		});
	};

	const handleBlur = (e) => {
		handleChange(e);
		setErrors(validateForm(form));
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		setErrors(validateForm(form));

		if (Object.keys(errors).length === 0) {

			const arrForm = {
				solicitudid: window.localStorage.getItem('solicitudid'),
				adjuntoid: adjuntoid,
				observaciones: form.observaciones,
				mark: form.mark,
				userid: storage.get('id')
			}

			setLoading(true);
			helpHttp()
				.post(`${BASE_API}demand/mark`, {
				body: arrForm,
				headers: {
					"Content-Type": "application/json; charset=utf-8",
					"Accept": "application/json",
					'Access-Control-Allow-Origin': '*',
					'x-access-token': storage.get('token')
				},
				})
				.then((res) => {
					if(res.response == 'on') {
						setLoading(false);
						setResponse(true);
						setMessage(res.message);
						setForm(initialForm);
						console.log(res.terminado);
						setTerminado(res.terminado);
						
						//setTimeout(() => setResponse(false), 5000);
						
						// if(res.terminado) {
						// 	handlerAviso(res.message);
						// }
					} else if(res.response == 'off'){
						setResponse(true);
						setMessage(res.message);
					}
				});
		} else {
			return;
		}
	};

	return {
		form,
		errors,
		loadup,
		response,
		message,
		terminado,
		handleChange,
		handleBlur,
		handleSubmit
	};
};